// @flow

import { Toast } from '@shopify/app-bridge/actions';
import { getSABAppInstance_Normal } from './app';

/**
 * Show toast message
 * @param  {string} message message to show
 * @param  {boolean} isError error option
 */
export const showSABToast = (message: string, isError: boolean = false) => {
  const toastOptions = {
    message: message,
    duration: 5000,
    isError: isError
  };
  const toastNotice = Toast.create(getSABAppInstance_Normal(), toastOptions);
  toastNotice.dispatch(Toast.Action.SHOW);
};
